import { pipe } from "@/utils/common/funtional"
import { judge_value_valid } from "@/utils/chart/verification"
import { 
    CITY_ORDERS_TW, CITY_ORDERS_EN, 
    monitor_signs_normal_mapping_css,
    monitor_signs_icon_name_mapping 
} from "@/config/monitor_config.js"

export const judge_invalid_data_by_keys = (datum, keys) => {
    const IN_VALID_VALUE = ['None', 'NaN', 'nan', '', '--','無']
    const is_valid = keys.some(key => {
        return !IN_VALID_VALUE.includes(datum[key])
    })
    return is_valid
}

export const sort_table_data = (data, severity_mapping) => {
    const pre_order_data = [...data]
        .filter(datum => judge_invalid_data_by_keys(datum, ['警示']))
        .sort((a, b) => a['項次'] ? a['項次'] - b['項次'] : a['編號'] - b['編號'])
        .sort((a, b) => severity_mapping[a['警示']] - severity_mapping[b['警示']])
    const other_data = [...data]
        .filter(datum => !judge_invalid_data_by_keys(datum, ['警示']))
        .sort((a, b) => a['項次'] ? a['項次'] - b['項次'] : a['編號'] - b['編號'])
    return [...pre_order_data, ...other_data]
}

export const sort_callback_by_city_name_tw = (prev_datum, next_datum) => {
    const prev_city = prev_datum['縣市']
    const next_city = next_datum['縣市']
    return CITY_ORDERS_TW.indexOf(prev_city) - CITY_ORDERS_TW.indexOf(next_city)
}

export const sort_callback_by_city_name_en = (prev_datum, next_datum) => {
    const prev_city = prev_datum['County/City']
    const next_city = next_datum['County/City']
    return CITY_ORDERS_EN.indexOf(prev_city) - CITY_ORDERS_EN.indexOf(next_city)
}

export const covert_to_float = (value, default_value = -1 ) => {
    return judge_value_valid(value) ? parseFloat(value) : default_value
} 

export const sort_float_callback_by_given_key = (key, options = {}) => {
    const { 
        from = 'max',
        default_float_value,
    } = options
    return (a, b) => {
        const a_float = covert_to_float(a[key], default_float_value)
        const b_float = covert_to_float(b[key], default_float_value)
        return from === 'min' ? a_float - b_float : b_float - a_float
    };
}

export const sort_by_column = (column) => {
    return (prev, next) => prev[column] - next[column]
}

export const calc_accumulated_precp_level = (row_data) => {
    const rainfall_24hr = covert_to_float(row_data['24小時'])
    const rainfall_3hr = covert_to_float(row_data['3小時'])
    const rainfall_1hr = covert_to_float(row_data['1小時'])
    
    // 四種雨量分級，超大豪雨及大豪雨標記一樣
    if (rainfall_24hr >= 500) {
        return 'row_head_border custom_red'
    } else if (rainfall_24hr >= 350 || rainfall_3hr >= 200) {
        return 'row_head_border custom_red'
    } else if (rainfall_24hr >= 200 || rainfall_3hr >= 100) {
        return 'row_head_border custom_orange'
    } else if (rainfall_24hr >= 80 || rainfall_1hr >= 40) {
        return 'row_head_border custom_yellow'
    }
}

export const reconstruct_alert_content = (table_contents, be_reconstructed_content) => {
    const new_alert_content = table_contents.map(content => {
        const new_content = be_reconstructed_content.reduce((accumulator, html_header) => {
            const signal_class = monitor_signs_normal_mapping_css[content[html_header]]
            if(!signal_class) return accumulator 
            
            const icon_class = monitor_signs_icon_name_mapping[content[html_header]]
            return {
                ...accumulator,
                [html_header]: [{
                    'html': `<i class="v-icon ${icon_class} ${signal_class}"></i>`,
                    'td_class': `td__${signal_class}`
                }]
            }
        }, {})

        return { ...content, ...new_content }
    })

    return new_alert_content
}

export const add_gust_interval_label_callback = (be_changed_datum_key = '瞬間風(m/s)') => {
    const OLD_GUST_KEY_MAPPING = {
        '瞬間風(級)': '陣風(級)',
        '瞬間風(m/s)': '陣風(m/s)'
    }

    return datum => {
        const gust_value = datum[be_changed_datum_key] || datum[OLD_GUST_KEY_MAPPING[be_changed_datum_key]]
        const gust_with_10_min_label = datum['瞬間風種類'] === '10分鐘最大瞬間風' ? `${gust_value}⁺` : ''
        const gust_with_1_hour_label = datum['瞬間風種類'] === '1小時最大瞬間風' ? `${gust_value}*` : ''
        return {
            ...datum,
            [be_changed_datum_key]: gust_with_10_min_label || gust_with_1_hour_label || gust_value
        }
    }
}